export default __webpack_public_path__ + "static/media/notification-user.eea348de.svg";